/**
 * Placeholder paths that already have a real route in app.routes.ts
 * (registered before buildPlaceholderRoutes). Keep these visible in the menu.
 *
 * Do not edit by hand. Run: node tools/sync-hidden-nav-inventory.mjs
 * When implementing a hidden screen: add the real route on the exact placeholder
 * path, then re-run the sync script so the path moves from hidden → claimed.
 */
export const IMPLEMENTED_PLACEHOLDER_PATHS = new Set<string>([
  'catalog/categories',
  'catalog/attributes',
  'catalog/media',
  'growth/crm/leads',
  'growth/crm/segments',
  'growth/crm/customer-360',
  'growth/marketing/campaigns',
  'growth/marketing/content-assets/new',
  'growth/marketing/content-calendar',
  'growth/marketing/approval-queue',
  'growth/marketing/ace-studio',
  'growth/marketing/article-publishing',
  'growth/strategy/activation-plans',
  'growth/journey/discoveries',
  'growth/journey/journeys',
  'growth/journey/brand-voice-profiles',
  'growth/marketing/publish-operations',
  'growth/concierge',
  'growth/agents/strategy-artifacts',
  'growth/comms/channels',
  'growth/comms/social-posts',
  'growth/integration/connectors',
  'growth/integration/sync-status',
  'growth/paid-media/accounts',
  'growth/paid-media/campaign-links',
  'growth/paid-media/audience-sync',
  'growth/paid-media/roas',
  'growth/search-ops',
  'growth/search-ops/properties',
  'growth/search-ops/backlog',
  'growth/search-ops/coworkers',
  'growth/search-ops/keywords',
  'growth/search-ops/urls',
  'growth/search-ops/issues',
  'growth/search-ops/redirects',
  'growth/search-ops/apply-queue',
  'growth/search-ops/offpage',
  'growth/search-ops/local',
  'growth/search-ops/sem',
  'growth/search-ops/scorecard',
  'growth/search-ops/reports',
  'growth/seo/profiles',
  'growth/search/geo/profiles',
  'growth/aeo/answers',
  'growth/sxo/experiments',
  'growth/intelligence/attribution',
  'growth/intelligence/funnels',
  'growth/intelligence/cohorts',
  'growth/intelligence/forecasts',
  'growth/agents/definitions',
  'growth/agents/recommendations',
  'growth/agents/approval-queue',
  'growth/optimizer/console',
  'growth/optimizer/optimization-runs',
  'growth/consent/preference-center',
  'growth/tenant-config',
  'growth/twin/business-twin',
  'growth/twin/scenarios',
  'growth/service/success-plans',
  'growth/service/retention-plays',
  'growth/marketplace/listings',
  'growth/marketplace/agent-installs',
  'growth/marketplace/installs',
  'growth/marketplace/bindings',
  'growth/analytics/revops-dashboard'
]);
